// src/components/LanguageSwitcher.js

import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { Button } from 'react-bootstrap';
import './LanguageSwitcher.css'; // Optional: For additional styling

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);
  
  const handleToggle = () => {
    // Toggle between 'en' and 'ka'
    const newLanguage = language === 'en' ? 'ka' : 'en';
    toggleLanguage(newLanguage);
  };

  // Function to render flag based on language
  const renderFlag = (lang) => {
    if (lang === 'ka') {
      return (
        <img
          src="https://flagcdn.com/w20/ge.png" // Georgian flag (20px width)
          alt="Georgian Flag"
        />
      );
    }
    if (lang === 'en') {
      return (
        <img
          src="https://flagcdn.com/w20/us.png" // US flag for English (20px width)
          alt="English Flag"
        />
      );
    }
    return (
      <img
        src="https://flagcdn.com/w20/un.png" // Generic globe icon (using UN flag as placeholder)
        alt="Global"
      />
    );
  };

  return (
    <Button
      id="language-switcher"
      onClick={handleToggle}
      variant="secondary"
      aria-label="Language Switcher"
      className="d-flex align-items-center"
      style={{ minHeight: '33px', minWidth: '33px' }}
    >
      {renderFlag(language)}
      <span className="d-none d-md-inline ms-1">
        {language === 'en' ? 'English' : 'ქართული'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;
